import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, Output, AfterContentInit, ContentChild,
  AfterViewChecked, AfterViewInit, ViewChild,ViewChildren } from '@angular/core';

@Component({
  selector: 'prompt',
  templateUrl: './prompt.component.html',
  styleUrls: ['./prompt.component.css']
})
export class PromptComponent implements AfterViewInit {
  
  @ViewChildren('input') vc;
  
   ngAfterViewInit() {            
        this.vc.first.nativeElement.focus();
    }

  public promptValue:string;
  public promptLabel:string;

  constructor(public activeModal: NgbActiveModal,) { }

}



// WEBPACK FOOTER //
// C:/git/flowdesigner/src/app/prompt/prompt.component.ts